import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxios from "../useAxios";
export default function InputPage() {
  const [name, setName] = useState("");
    const [showDialog, setShowDialog] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
  const axiosData = useAxios();
  async  function onSubmit(e) {
    try{
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
     setLoading(true);
    setErrorMsg("");
    const postData =await  axiosData.post("createData/save",{
      name:trimmed
    })
    if(postData){
        setShowDialog(true); 
         setName("");  
      //navigate(`/galaxy?name=${encodeURIComponent(trimmed)}&t=${Date.now()}`);
    }}
    catch(err){
        setErrorMsg("Could not submit. Please try again.");
      console.error("save failed", err);
    }finally {
      setLoading(false);
    }
  }

  return (
    <div className="screen screen--landing homepage">
    

      <form className="name-form" onSubmit={onSubmit}>
        <div className="splited-input">
        <label className="label">Name</label>
        <input
          className="input"
          placeholder="Type your name…"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={40}
           disabled={loading}
        />
        </div>
        <button className="btn" type="submit">{loading ? "Submitting…" : "Submit"}</button>
        {errorMsg && <div className="form-error">{errorMsg}</div>}
      </form>
 {/* Dialog */}
      {showDialog && (
        <div className="modal-backdrop" onClick={() => setShowDialog(false)}>
          <div
            className="modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="dialog-title"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h3 id="dialog-title" className="modal-title">Submitted ✅</h3>
            <p className="modal-body">
              Your name has been added to the galaxy wall.
              Check the big screen!
            </p>
            <div className="modal-actions">
              <button className="btn btn-outline" onClick={() => setShowDialog(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flare" />
    </div>
  );
}
